import fetch from 'services'

export const getUser = () => fetch(`/users/account`)

export const signupUser = (userData) =>
    fetch(`/auth/signup/email`, {
        method: 'POST',
        data: userData,
    })

export const loginUser = (userData) =>
    fetch(`/auth/signin/email`, {
        method: 'POST',
        data: userData,
    })

export const removeNewUser = () => () =>
    fetch(`/users`, {
        method: 'PUT',
        data: { isFirstTime: false },
    })

export const triggerResetPassword = (email) =>
    fetch(`/users/account/triggerResetPassword`, {
        method: 'POST',
        data: { email },
    })

export const resetPassword = (email, token, password) =>
    fetch(`/users/account/resetPassword`, {
        method: 'POST',
        data: {
            email,
            token,
            password,
        },
    })

export const requestEarlyAccess = (email) =>
    fetch(`/users/earlyAccessSubscribe`, {
        method: 'POST',
        data: { email },
    })

export const requestChangePassword = (currentPassword, newPassword) =>
    fetch('/users/password', {
        method: 'PUT',
        data: {
            password: currentPassword,
            new_password: newPassword,
        },
    })

export const deleteUser = () =>
    fetch(`/users/delete`, {
        method: 'DELETE',
    })
